import moment from 'moment';
import coBrandedCards from '../../../../constants/user-profile';
import {
  bagNames,
  getAncillaryNameInsurance,
  getDtd,
  getFareType,
  passengerCount,
  sortAlphabetically,
} from '../../../../utilities/helpers';
import { cardTypes } from '../../../utils/metrics-utils';
import { CARRY_ON_LABELS } from './constants';

export default (pnrData, paymentFormData) => {
  const pnrInfo = pnrData;
  const items = [];
  let tripType = 'MC';
  const segments = [];
  let zone = 'NA';
  const legCollection = pnrInfo?.legCollection || [];
  const outboundSegments = legCollection?.[0]?.segmentsCollection || [];
  const inboundSegments = legCollection?.[legCollection?.length - 1]?.segmentsCollection || [];
  let fopType = '';
  let stopNumbers = 0;

  if (pnrInfo?.flightItineraryType === 'ONEWAY') {
    tripType = 'OW';
  } else if (pnrInfo?.flightItineraryType === 'ROUNDTRIP') {
    tripType = 'RT';
  }

  if (legCollection?.length > 0) {
    legCollection.forEach((element) => {
      const segmentsInfo = element?.segmentsCollection || [];
      stopNumbers = segmentsInfo?.length > 1 ? stopNumbers + (segmentsInfo?.length - 1) : stopNumbers;
      segmentsInfo.forEach((segmentsData) => {
        segments.push(segmentsData);
      });
    });
  }

  let cardType = paymentFormData?.values ? cardTypes[paymentFormData?.values?.cardType] : cardTypes[paymentFormData?.cardType];
  cardType = cardType ? cardType : 'NA';
  let bankId = paymentFormData?.values ? paymentFormData?.values?.cardCode : paymentFormData?.cardCode;
  const paymentValues = paymentFormData?.values;
  let paymentType = paymentValues?.cardCode || paymentFormData?.cardCode ? 'CREDIT CARD' : 'UATP';

  const points = pnrInfo?.cart?.total?.totalCPPoints;
  const cash = pnrInfo?.cart?.total?.total;

  if (paymentType === 'UATP') {
    cardType = 'UATP';
    bankId = 'TP';
  }

  if (points > 0 && cash > 0) {
    paymentType = 'Both';
  } else if (points > 0) {
    paymentType = 'AMR Points';
    bankId = 'NA';
    cardType = 'NA';
  } 

  const apiDepartureDate = moment(segments?.[0]?.departureDateTime);
  const transactionDate = moment(pnrInfo?.creationDate);
  const apiItem = apiDepartureDate.diff(transactionDate, 'days');
  const dtd = getDtd(segments?.[0]?.departureDateTime);
  const inboundDepartureDate = pnrInfo?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') : 'NA';
  const inboundArrivalDate = pnrInfo?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[inboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD') : 'NA';
  const arrivalAirport = outboundSegments?.[outboundSegments?.length - 1]?.arrivalAirport || 'NA';
  const departureAirport = outboundSegments?.[0]?.departureAirport || 'NA';
  const marketOd = `${departureAirport}${arrivalAirport}`;
  const outboundDepartureDate = outboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') || 'NA';
  const outboundArrivalDate = outboundSegments?.[outboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD');
  const inboundArrivalAirport = inboundSegments?.[inboundSegments?.length - 1]?.arrivalAirport || 'NA';
  const inboundDepartureAirport = inboundSegments?.[0]?.departureAirport || 'NA';
  const purchaseOrderCcNumber = paymentFormData?.cardNumber;
  const personalCreditCardsUser = pnrInfo?.userProfile?.personalCreditCards?._collection || [];
  const outboundName = marketOd;
  const inboundName =  `${inboundDepartureAirport}${inboundArrivalAirport}`;
  let isCobrandCard = null;
  let shareBrand = 'NA';
  let cobrandCardNames = null;

  const mcOutBoundDepartureDate = (legCollection || []).map((legData) => {
    const firstSegment = legData?.segmentsCollection[0] || [];
    const departureDate = firstSegment?.departureDateTime?.format('YYYYMMDD') || 'NA';
    return departureDate;
  }).join('-');

  const mcOutBoundArrivalDate = (legCollection || []).map((legData) => {
    const lastSegment = legData?.segmentsCollection[legData?.segmentsCollection?.length - 1] || [];
    const arrivalDate = lastSegment?.arrivalDateTime?.format('YYYYMMDD') || 'NA';
    return arrivalDate;
  }).join('-');

  personalCreditCardsUser.forEach((element) => {
    if (purchaseOrderCcNumber === element?.ccNumber) {
      isCobrandCard = element?.isCobranCard;
      if (isCobrandCard) {
        cobrandCardNames = element?.codeCobranCard;
      }
    }
  });

  if (cobrandCardNames) {
    shareBrand = coBrandedCards?.COBRANDED_CARDS_NAMES?.[cobrandCardNames];
  }

  let apItemRange = '';
  switch (true) {
    case (apiItem >= 0 && apiItem <= 2):
      apItemRange = '0 a 2';
      break;
    case (apiItem >= 3 && apiItem <= 6):
      apItemRange = '3 a 6';
      break;
    case (apiItem >= 7 && apiItem <= 13):
      apItemRange = '7 a 13';
      break;
    case (apiItem >= 14 && apiItem <= 20):
      apItemRange = '14 a 20';
      break;
    case (apiItem >= 21 && apiItem <= 27):
      apItemRange = '21 a 27';
      break;
    case (apiItem >= 28 && apiItem <= 49):
      apItemRange = '28 a 49';
      break;
    case (apiItem >= 50 && apiItem <= 89):
      apItemRange = '50 a 89';
      break;
    case (apiItem >= 90 && apiItem <= 119):
      apItemRange = '90 a 119';
      break;
    case (apiItem >= 120 && apiItem <= 149):
      apItemRange = '120 a 149';
      break;
    case (apiItem >= 150):
      apItemRange = '150+';
      break;
    default:
      apItemRange = 'NA';
      break;
  }

  let msItem = 0;
  if (tripType === 'RT') {
    const firstSegment = moment(segments?.[0]?.departureDateTime);
    const lastSegment = moment(segments?.[segments?.length - 1]?.arrivalDateTime);
    msItem = lastSegment.diff(firstSegment, 'days');
  }

  let marketSegment = [];
  segments.forEach(segment => {
    marketSegment.push(`${segment?.departureAirport}${segment?.arrivalAirport}`);
  });

  let marketNdod = `${arrivalAirport}${departureAirport}` || 'NA';
  if (departureAirport < arrivalAirport) {
    marketNdod = `${departureAirport}${arrivalAirport}`;
  }

  const marketTest = [];
  const bookingClassTest = [];
  const cabinClassTest = [];
  legCollection.forEach((element) => {
    const segmentsInfo = element?.segmentsCollection || [];
    const tmpMarketSegmet = [];
    const bookingClass = [];
    const cabinClass = [];
    segmentsInfo.forEach((segmentsData) => {
      tmpMarketSegmet.push(`${segmentsData?.departureAirport}${segmentsData?.arrivalAirport}`);
      bookingClass.push(segmentsData?.bookingClass || 'NA');
      cabinClass.push(segmentsData?.cabin || 'NA');
    });
    marketTest.push(tmpMarketSegmet.join('/'));
    bookingClassTest.push(bookingClass.join('/'));
    cabinClassTest.push(cabinClass.join('/'));
  });
  marketSegment = marketTest.join('-');
  const bookingClassSegment = bookingClassTest.join('-');
  const cabinClassSegment = cabinClassTest.join('-');

  const travelerCollection = pnrInfo?.cart?.travelerCollection || [];
  const travelerCount = passengerCount(travelerCollection);
  const market = pnrInfo?.globalMarketFlight;

  if (market === 'DOMESTIC') {
    zone = 'DOM';
  } else if (market === 'INTERNATIONAL' || market === 'TRANSBORDER') {
    zone = 'INT';
  }

  const ancillaries = pnrInfo?.getAllUnPaidAncillaries();
  const seatAncillaries = pnrInfo?.cart?.getAllUnPaidSegmentChoice();

  const upgFilterAncillariesArray = (ancillaries || []).filter(( { ancillary } ) => ancillary?.type === 'UPG');
  const nonUpgFilterAncillariesArray = (ancillaries || []).filter(( { ancillary } ) => ancillary?.type != 'UPG');
  const ancillariesArray = nonUpgFilterAncillariesArray?.map(({ ancillary, legCode, segmentCode }) => ({ redeemedCP: ancillary?.redeemedCP, segmentCode: segmentCode, commercialName: ancillary?.commercialName, type: ancillary?.type, totalCPPoints: ancillary?.currency?.totalCPPoints, total: ancillary?.currency?.total, legCode: legCode }));
  const seatAncillariesArray = seatAncillaries?.map((currentSeat) => ({ redeemedCP: currentSeat?.redeemedCP, commercialName: 'seat', type: currentSeat?.seat?.code, totalCPPoints: currentSeat?.seat?.currency?.totalCPPoints, total: currentSeat?.seat?.currency?.total, segmentCode: currentSeat?.segmentCode }));
  const upgAncillariesArray = (upgFilterAncillariesArray || []).map(( { ancillary }) => ({ redeemedCP: ancillary?.redeemedCP, segmentCode: ancillary?.segmentCode, commercialName: 'UPG', type: ancillary?.ancillaryOffer?.ancillary?.type, totalCPPoints: ancillary?.ancillaryOffer?.ancillary?.currency?.totalCPPoints, total: ancillary?.ancillaryOffer?.ancillary?.currency?.total }));
  const allAncillaries = [...ancillariesArray, ...seatAncillariesArray, ...upgAncillariesArray];

  const allCash = allAncillaries?.every(({ redeemedCP }) => redeemedCP === false);
  const allPoints = allAncillaries?.every(({ redeemedCP }) => redeemedCP === true);

  let fopTpeItem = 'Cash';

  if (allCash) {
    fopType = 'Cash';
  } else if (allPoints) {
    fopType = 'Points';
  } else {
    fopType = 'Cash+points';
  }

  let mcPrice = 0;
  (pnrInfo?.products || []).forEach((product) => {
    const productId = product?.id;
    const baggageId = ['0IA', '0CD', '0CE', '0CF', '0CG', '0CH', '0CI', '0LX', '0JH', '0LL', '02T', 'XB5', 'XB6', 'XB7'];
    const baggage = baggageId?.includes(productId);
    const seatTypes = ['AMPlus Seat', 'Emergency Exit Seat', 'Preferred Seat', 'Seat Choice'];
    const seat = seatTypes?.includes(product?.name);
    const itemAffiliation = 'AM';
    let itemCategory = 'Ancillary';
    let itemCategory2 = 'NA';
    let itemCategory3 = 'NA';
    let marketSegmentsItem = 'NA';
    let price = 0;
    let mcFlightTime = 0;
    let quantity = 0;
    const leg = product?.category;
    let itemListName = 'NA';
    let currentAncillary = (allAncillaries || []).find(product2 => product2.type === productId);
    fopTpeItem = currentAncillary?.redeemedCP ? 'Points' : 'Cash';
    switch (productId) {
      case 'AMS':
      case 'SEP':
      case 'SDE':
      case 'SXC':
      case 'SXP':
      case 'SVI':
        itemCategory = 'Insurance';
        itemCategory2 = getAncillaryNameInsurance(product?.id);
        price = product?.price;
        quantity = product?.quantity;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Insurance outbound' :
          'Insurance outbound and Insurance inbound';
        break;
      case 'AMK':
        itemCategory = 'Services';
        itemCategory2 = 'Concierge';
        itemCategory3 = 'NA';
        price = product?.price;
        quantity = product?.quantity;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Services outbound' :
          'Services outbound and services inbound';
        break;
      case 'DPM':
      case 'DPI':
        itemCategory = 'Services';
        itemCategory2 = 'Discount Pass';
        itemCategory3 = pnrInfo?.globalMarketFlight === 'DOMESTIC' ? 'MEXICO' : 'INTERNATIONAL';
        price = product?.price;
        quantity = product?.quantity;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Services outbound' :
          'Services outbound and services inbound';
        break;
      case '09T':
        itemCategory = 'Services';
        itemCategory2 = 'Fly Green';
        itemCategory3 = 'NA';
        price = product?.price;
        quantity = product?.quantity;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Ancillaries outbound' :
          'Ancillaries outbound ancillaries inbound';
        break;
      case '07X':
        itemCategory2 = CARRY_ON_LABELS.CARRY_ON;
        itemCategory3 = CARRY_ON_LABELS.CARRY_ON_PLUS_5KG;
        price = product?.price;
        quantity = product?.quantity;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Ancillaries outbound' :
          'Ancillaries outbound ancillaries inbound';
        break;
      case '0CZ':
        itemCategory2 = CARRY_ON_LABELS.CARRY_ON;
        itemCategory3 = CARRY_ON_LABELS.CARRY_ON_10KG;
        price = product?.price;
        quantity = product?.quantity;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Ancillaries outbound' :
          'Ancillaries outbound ancillaries inbound';
        break;
      case '029':
        itemCategory2 = 'CBX';
        itemCategory3 = 'NA';
        price = product?.price;
        quantity = product?.quantity;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Ancillaries outbound' :
          'Ancillaries outbound ancillaries inbound';
        break;
      case 'UPG':
        itemCategory = 'Upgrade';
        itemCategory2 = segments?.[0]?.fareFamily;
        const noOfPassengers = pnrInfo?.cart?.travelerCollection?.length;
        price = product?.price * noOfPassengers;
        quantity = travelerCount?.adults + travelerCount?.child + travelerCount?.adultMinors;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'upgrade outbound' :
          'Upgrade outbound upgrade inbound';
        break;
      default:
        if (seat) {
          itemCategory2 = 'Seat';
          itemCategory3 = product?.name + '|' + product.id;
          price = product?.price;
          quantity = product?.quantity;
          itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Ancillaries outbound' :
            'Ancillaries outbound ancillaries inbound';
        }
        break;
    }

    if (baggage) {
      itemCategory2 = 'Luggage';
      const productname = product?.name;
      const split = productname?.split('/');
      const bagName = split?.[0];
      itemCategory3 = bagNames(bagName);
      price = product?.price;
      quantity = product?.quantity;
      itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Ancillaries outbound' :
        'Ancillaries outbound ancillaries inbound';
    }

    itemCategory2 = itemCategory2?.trim();
    itemCategory3 = itemCategory3?.trim();
 
    let pricePoint = currentAncillary?.redeemedCP ? currentAncillary?.totalCPPoints : 0;
    if (currentAncillary?.redeemedCP) {
      price = 0;
    }
    
    let legParams = {};
    legCollection.forEach((legs, legIndex) => {
      const legType = legs?.itineraryPartType;
      const ancillaries = ['Concierge', 'Discount Pass'];
      const upgradeItemName = ['Upgrade'];
      const flyGreenItem = ['Fly Green'];
      const cbxItem = ['CBX'];
      const luggageItems = ['Luggage', 'hand luggage'];
      const isFlyGreen = flyGreenItem.includes(itemCategory2);
      const isCBX = cbxItem.includes(itemCategory2);
      const isBaggage = luggageItems?.includes(itemCategory2);
      const ancillaryIncluded = ancillaries?.includes(itemCategory2) || itemCategory === 'Insurance';
      currentAncillary = isCBX ? (allAncillaries || []).find((produc) => produc?.legCode === legs?.legCode) : 
        isBaggage ? (allAncillaries || []).find((produc) => produc?.legCode === legs?.legCode && productId === produc.type) : currentAncillary;
      const isSameLegCode = legs?.legCode === currentAncillary?.legCode;
      let nameToCompare = legs?.itineraryPartType === 'OUTBOUND' ? outboundName : inboundName;
      const firstSegments = legs?.segmentsCollection?.[0];
      const lastSegments = legs?.segmentsCollection?.[legs?.segmentsCollection?.length - 1];
      const lastSegmentsAirport = lastSegments?.arrivalAirport || 'NA';
      const firstSegmentsAirport = firstSegments?.departureAirport || 'NA';
      nameToCompare = tripType === 'MC' ? `${firstSegmentsAirport}${lastSegmentsAirport}` : nameToCompare;

      if (isBaggage && isSameLegCode) {
        fopTpeItem = currentAncillary?.redeemedCP ? 'Points' : 'Cash';
        pricePoint = currentAncillary?.redeemedCP ? currentAncillary?.totalCPPoints : 0;
        price = currentAncillary?.redeemedCP ? 0 : currentAncillary?.total;
      }

      if (isCBX && isSameLegCode) {      
        const index2 = items?.findIndex((item) => item?.item_name === nameToCompare);
        if (index2 !== -1) return;
        quantity = (allAncillaries || []).filter((produc) => produc?.legCode === legs?.legCode).length;
        price = currentAncillary?.total;
      }
      
      if ((isBaggage || isCBX) && !isSameLegCode) {
        return;
      }

      if (ancillaryIncluded && (legs?.itineraryPartType === 'OUTBOUND' || legIndex === 0)) {
        (legs?.segmentsCollection || []).forEach((passenger, index) => {
          if (index > 0) return;
          const departureDateTime = moment(passenger?.departureDateTime).format('YYYYMMDD HH:mm:ss');
          const flightTime = moment?.utc().startOf('day').add({ minutes: legs?.totalFlightTimeInMinutes }).format('HH:mm');
          const itemBrand = itemCategory === 'Insurance' ? 'CHUBB' : 'AM';
          const marketNdodItem = marketNdod;
          const opCarrier = passenger?.operatingCarrier;
          const brandedFare = getFareType(passenger);
          if (pnrInfo?.isOnHold) {
            itemListName = tripType === 'RT' ? 'Flights outbound and inbound' : 'Flights outbound';
          }
          legParams = {
            'item_name': marketOd || 'NA',
            'coupon': 'NA',
            'discount': 0,
            'item_brand': itemBrand,
            'item_category': itemCategory,
            'item_category2': itemCategory2,
            'item_category3': itemCategory3,
            'item_list_name': itemListName,
            'item_affiliation': itemAffiliation,
            'price': price,
            'quantity': quantity,
            'index': index,
            'booking_fee_amrpoints': 0,
            'market_ndod_item': marketNdodItem || 'NA',
            'market_od_item': marketOd || 'NA',
            'market_segment_item': marketSegment,
            'zone_item': passenger?.marketFlightFromLeg === 'DOMESTIC' ? 'DOM' : 'INT' || 'NA',
            'region_item': passenger?.regionKeyFromLeg || 'NA',
            'flight_time_dep': departureDateTime || 'NA',
            'flight_time': flightTime || 'NA',
            'branded_fare': brandedFare === 'MAIN_LIGHT' ? 'LIGHT' : brandedFare,
            'upsell_amount': 0,
            'outbound_departure_date_item': outboundDepartureDate || 'NA',
            'inbound_departure_date_item': inboundDepartureDate,
            'fop_type_item': fopTpeItem,
            'price_points': pricePoint || 0,
            'airport_tax': pnrInfo?.cart?.total?.taxDetails?.TUA || 0,
            'aircraft_type': passenger?.aircraftType || 'NA',
            'aircraft_subfleet': `${opCarrier}${passenger?.aircraftType}` || 'NA',
            'ap_item': apItemRange,
            'ms_item': msItem,
            'cabin_item': passenger?.cabin || 'NA',
            'class_item': passenger?.bookingClass || 'NA',
          };
          items.push(legParams);
        });
      } else if (!ancillaryIncluded) {
        const connectedFlights = legs?.legType === 'CONNECTING' && baggage ? [legs?.segmentsCollection?.[0]] : legs?.segmentsCollection;
        (connectedFlights || []).forEach((passenger, index) => {
          const departureDateTime = moment(passenger?.departureDateTime).format('YYYYMMDD HH:mm:ss');
          const flightTime = moment?.utc(passenger?.flightDurationInMinutes * 60000).format('HH:mm');
          const itemBrand = 'AM';
          let aircraftType = 'NA';
          let aircraftSubfleet = 'NA';
          let cabinItem = 'NA';
          let classItem = 'NA';
          let inboundDepartureDateItem = 'NA';
          let outboundDepartureDateItem = 'NA';
          let marketOdItem = passenger?.departureAirport + passenger?.arrivalAirport;
          let marketNdodItem = sortAlphabetically(passenger?.arrivalAirport, passenger?.departureAirport) || 'NA';
          const segment = passenger?.departureAirport + '-' + passenger?.arrivalAirport;
          let segmentCheck = false;
          const connectingFlights = legs?.segmentsCollection || [];
          const brandedFare = getFareType(passenger);
          if (leg?.includes(segment)) {
            segmentCheck = true;
          } else if (leg?.includes(connectingFlights?.[0]?.departureAirport + '-' + connectingFlights?.[connectingFlights?.length - 1]?.arrivalAirport)) {
            segmentCheck = true;
          }
          const isUpgrade = upgradeItemName?.includes(itemCategory);
          let currentUpg = null;
          let itemName = marketOdItem;
          let itemListName = legType === 'OUTBOUND' ? 'Ancillaries outbound' : 'Ancillaries inbound';
          currentAncillary = seat ? (allAncillaries || []).find((produc) => produc?.segmentCode === passenger?.segmentCode && produc?.type === productId) : currentAncillary;
          const isSameSegmentCode = passenger?.segmentCode === currentAncillary?.segmentCode;

          if (seat && isSameSegmentCode) {
            fopTpeItem = currentAncillary?.redeemedCP ? 'Points' : 'Cash';
            pricePoint = currentAncillary?.redeemedCP ? currentAncillary?.totalCPPoints : 0;
            price = currentAncillary?.redeemedCP ? 0 : currentAncillary?.total;
          }
          
          itemListName = tripType === 'MC' ? 'Ancillaries outbound' : itemListName;

          if (isUpgrade) {
            itemListName = legType === 'OUTBOUND' ? 'Upgrade outbound' : 'Upgrade inbound';
            itemListName = tripType === 'MC' ? 'Upgrade outbound' : itemListName;

            currentUpg = upgAncillariesArray?.find((upg) => upg?.segmentCode === passenger?.segmentCode);
            fopTpeItem = currentUpg?.redeemedCP ? 'Points' : 'Cash';
            pricePoint = currentUpg?.redeemedCP ? currentUpg?.totalCPPoints : 0;
            price = currentUpg?.redeemedCP ? 0 : currentUpg?.total;
            const index = items?.findIndex((item) => item?.item_category === 'Upgrade' && item?.item_name === marketOdItem && departureDateTime === item?.flight_time_dep); 
            if (!currentUpg || index != -1) return;
            segmentCheck = true;
          }

          if (isCBX) {
            if (index > 0) return;
            itemName = legs?.itineraryPartType == 'OUTBOUND' ? outboundName : inboundName;
            itemName = tripType === 'MC' ? `${firstSegmentsAirport}${lastSegmentsAirport}` : itemName;
            itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Ancillaries outbound' : itemListName;
          }
          
          if (isFlyGreen) {
            const index2 = items?.findIndex((item) => item?.item_category2 === 'Fly Green' && item?.item_name === marketOdItem && departureDateTime === item?.flight_time_dep);
            currentAncillary = allAncillaries.find((item) => item?.segmentCode === passenger?.segmentCode && productId === item.type && item?.legCode === legs?.legCode);
            if (index2 !== -1 || !currentAncillary) return;
            quantity = (allAncillaries || []).filter((item) => (item?.segmentCode === passenger?.segmentCode) && productId === item.type).length;
            price = currentAncillary?.total;
            segmentCheck = true;
          }

          if (pnrInfo.isOnHold && legType === 'OUTBOUND') {
            itemListName = 'Flights outbound';
            itemListName = tripType === 'MC' ? 'Flights outbound' : itemListName;
          } else if (pnrInfo.isOnHold && legType === 'INBOUND') {
            itemListName = 'Flights inbound';
            itemListName = tripType === 'MC' ? 'Flights outbound' : itemListName;
          }
          
          if ((baggage || isCBX) && legs?.legType === 'CONNECTING') {
            marketSegmentsItem = (connectingFlights || []).map((segment) => {
              return `${segment?.departureAirport || 'NA'}${segment?.arrivalAirport || 'NA'}`;
            }).join('/');
          }

          if (baggage && legs?.legType === 'CONNECTING') {
            mcPrice = 0;
            marketOdItem = connectingFlights?.[0]?.departureAirport + connectingFlights?.[connectingFlights?.length - 1]?.arrivalAirport;
            marketNdodItem = sortAlphabetically(connectingFlights?.[connectingFlights?.length - 1]?.arrivalAirport, connectingFlights?.[0]?.departureAirport) || 'NA';
            (connectingFlights || []).forEach((segment) => {
              mcPrice +=  segment?.layoverToNextSegmentsInMinutes + segment?.flightDurationInMinutes;
            });
            mcFlightTime = moment?.utc(mcPrice * 60000).format('HH:mm');
            outboundDepartureDateItem = legs?.itineraryPartType === 'OUTBOUND' || tripType === 'MC' ? connectingFlights?.[0]?.departureDateTime?.format('YYYYMMDD') + '/' + connectingFlights?.[connectingFlights?.length - 1]?.departureDateTime?.format('YYYYMMDD') : 'NA';
            inboundDepartureDateItem = legs?.itineraryPartType === 'INBOUND' && tripType === 'RT' ? connectingFlights?.[0]?.arrivalDateTime?.format('YYYYMMDD') + '/' + connectingFlights?.[connectingFlights?.length - 1]?.arrivalDateTime?.format('YYYYMMDD') : 'NA';
            aircraftType = connectingFlights?.[0]?.aircraftType + '/' + connectingFlights?.[connectingFlights?.length - 1]?.aircraftType;
            aircraftSubfleet = connectingFlights?.[0]?.operatingCarrier + connectingFlights?.[0]?.aircraftType + '/' + connectingFlights?.[connectingFlights?.length - 1]?.operatingCarrier + connectingFlights?.[connectingFlights?.length - 1]?.aircraftType;
            cabinItem = connectingFlights?.[0]?.cabin + '/' + connectingFlights?.[connectingFlights?.length - 1]?.cabin;
            classItem = connectingFlights?.[0]?.bookingClass + '/' + connectingFlights?.[connectingFlights?.length - 1]?.bookingClass;
          }
          
          const flightDuration = legs?.legType === 'CONNECTING' && baggage ? mcFlightTime : flightTime || 'NA';
          const marketSegmntItem = legs?.legType === 'CONNECTING' && (baggage || isCBX) ? marketSegmentsItem : marketOdItem || 'NA';
          const outbounDepartureItem = legs?.legType === 'CONNECTING' && baggage ? outboundDepartureDateItem : outboundDepartureDate || 'NA';
          const inboundDepartureItem = legs?.legType === 'CONNECTING' && baggage  ? inboundDepartureDateItem : inboundDepartureDate || 'NA';
          const airCraft = legs?.legType === 'CONNECTING' && baggage ? aircraftType : passenger?.aircraftType || 'NA';
          const CraftSubfleet =  legs?.legType === 'CONNECTING' && baggage ? aircraftSubfleet : passenger.operatingCarrier + passenger?.aircraftType || 'NA';
          const cabinItems = legs?.legType === 'CONNECTING' && baggage ? cabinItem : passenger?.cabin || 'NA';
          const classItems = legs?.legType === 'CONNECTING' && baggage ? classItem : passenger?.bookingClass || 'NA';
          
          if (segmentCheck) {
            legParams = {
              'item_name': itemName,
              'coupon': 'NA',
              'discount': 0,
              'item_brand': itemBrand,
              'item_category': itemCategory,
              'item_category2': itemCategory2,
              'item_category3': itemCategory3,
              'item_list_name': itemListName,
              'item_affiliation': itemAffiliation,
              'price': price,
              'quantity': quantity,
              'index': index,
              'booking_fee_amrpoints': 0,
              'market_ndod_item': marketNdodItem || 'NA',
              'market_od_item': marketOdItem || 'NA',
              'market_segment_item': marketSegmntItem,
              'zone_item': passenger?.marketFlightFromLeg === 'DOMESTIC' ? 'DOM' : 'INT' || 'NA',
              'region_item': passenger?.regionKeyFromLeg || 'NA',
              'flight_time_dep': departureDateTime || 'NA',
              'flight_time': flightDuration,
              'branded_fare': brandedFare === 'MAIN_LIGHT' ? 'LIGHT' : brandedFare,
              'upsell_amount': 0,
              'outbound_departure_date_item': outbounDepartureItem,
              'inbound_departure_date_item': inboundDepartureItem,
              'fop_type_item': fopTpeItem,
              'price_points': pricePoint || 0,
              'airport_tax': pnrInfo?.cart?.total?.taxDetails?.TUA || 0,
              'aircraft_type': airCraft,
              'aircraft_subfleet': CraftSubfleet,
              'ap_item': apItemRange,
              'ms_item': msItem,
              'cabin_item': cabinItems,
              'class_item': classItems,
            };
            items.push(legParams);
          }
        });
      }
    });
  });

  const updatedItems = items.filter((obj, index, item) =>
    index === item.findIndex((value) => (
      value?.price === obj?.price && value?.item_name === obj?.item_name && value?.item_category3 === obj?.item_category3 && value?.flight_time
      === obj?.flight_time
    ))
  );

  return {
    event: 'add_payment_info',
    ecommerce: {
      'currency': pnrInfo?.cart?.total?.currencyCode || 'NA',
      'value': pnrInfo?.cart?.total?.total || 0,
      'coupon': 'NA',
      'installments': paymentValues?.installmentPlanType?.numberOfMonths || paymentFormData?.installmentPlanType?.numberOfMonths || 0,
      'payment_type': paymentType,
      'card_type': cardType || 'NA',
      'share_brand': shareBrand,
      'bank_id': bankId || 'NA',
      'funnel_name': 'MYB',
      'sub_funnel_name': 'Payment',
      'trip_type': tripType,
      'fop_type': fopType || 'NA',
      'outbound_departure_date': tripType === 'MC' ? mcOutBoundDepartureDate : outboundDepartureDate || 'NA',
      'inbound_departure_date': inboundDepartureDate,
      'outbound_arrival_date': tripType === 'MC' ? mcOutBoundArrivalDate : outboundArrivalDate || 'NA',
      'inbound_arrival_date': inboundArrivalDate,
      'zone': zone,
      'market_od': marketOd || 'NA',
      'market_ndod': marketNdod || 'NA',
      'market_segment': marketSegment || 'NA',
      'region': legCollection?.[0]?.regionKey || 'NA',
      'value_points': points || 0,
      'adults': travelerCount?.adults,
      'childs': travelerCount?.child,
      'adult_minors': travelerCount?.adultMinors,
      'infants': travelerCount?.infants,
      'stops_number': stopNumbers,
      'dtd': dtd || 'NA',
      'clid_benefits': 'NA',
      'cabin': cabinClassSegment || 'NA',
      'class': bookingClassSegment || 'NA',
      'items': (legCollection?.[0]?.legType === 'CONNECTING' || legCollection?.[legCollection?.length - 1]?.legType === 'CONNECTING') ?  updatedItems : items,
    },
  };
};
